export function celsiusToFahrenheit(celsius: number): number {
  return (celsius * 9) / 5 + 32;
}

export function kgToPound(kg: number): number {
  return kg * 2.20462;
}

export function gToPound(g: number): number {
  return (g * 2.20462) / 1000;
}
